import React, { useEffect, useState } from 'react';
import { UserServiceClientApi } from '../../services/api/UserApiServices';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthData } from '../../services/storage/LocalStorage';
import { isEmpty } from 'lodash';
import {
    createConversation, getTimeLine, setSelectedGroupChat,
    setSelectedOnetoOneChat,
    updateTimeLine,
    setSelectedGroupChatparticipants,
    setActiveMessageChatArea,
    setActiveMessageChatAreaDetail,
} from '../../state/actions/chats';
import ChatScreen from './ChatScreen';
import ConnectSidebar from './ConnectSidebar';
import { updateProfileImage } from '../../state/actions/updateProfileImage';
import { getGroupProfileImageUrl, getUserInitials, getUserProfileImageUrl, getUserProfileImageUrlThumbnail, isValidImageUrl } from '../../utils/general';
import { fetchContacts } from '../../state/actions/contacts';
import { fullBotScriptReset } from '../../utils/ChatbotScriptHelpers';
import { channelAdmins } from '../../state/actions/channels';
import { appType } from '../../utils/config/configHelpers';


const Connect = () => {
    const [searchInput, setSearchInput] = useState('');
    const [activeFilter, setActiveFilter] = useState('all');
    const [avatarMap, setAvatarMap] = useState({});
    const [subscribedChannelsList, setSubscribedChannelsList] = useState([]);
    const [avatarUrl, setAvatarUrl] = useState(null);
    const [lockedMap, setLockedMap] = useState({});  // NEW 
    const chatLog = useSelector(state => state.chats.chatLog);
    const timeLine = useSelector(state => state.chats.timeLine);
    const contentList = useSelector(state => state.contacts.contentList);
    const activeMessageChatAreaDetail = useSelector(state => state.chats.activeMessageChatAreaDetail);
    const selectedDomain = useSelector((state) => state.domain.selectedDomain);
    const selectedDomainDetails = useSelector((state) => state.domain.selectedDomainDetails);
    const allProfileImages = useSelector((state) => state.profileImages);

    const [selectedContact, setSelectedContact] = useState(activeMessageChatAreaDetail);
    const [loader, setLoader] = useState(true);
    const [openLeaveModal, setOpenLeaveModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openGroupInfo, setOpenGroupInfo] = useState(false)
    const [isShimmerLoading, setIsShimmerLoading] = useState(true);
    const [selectedContactDomain, setSelectedContactDomain] = useState(null);
    const [reloadChat, setReloadChat] = useState(false);
    const [selectedChatFilter, setSelectedChatFilter] = useState('');

    const userDetail = getAuthData();
    const userData = userDetail.user || {};
    const userID = userDetail.user?.userId;

    const dispatch = useDispatch();

    const uniqueConversations = Array.from(
        new Map(
            timeLine
                .filter((conv) => conv.channel || conv.contact)
                .map((conv) => [conv.conversationId, conv])
        ).values()
    );

    const unReadCount = uniqueConversations.filter(c => c.unreadCount > 0).length;
    const favouriteCount = uniqueConversations.filter(c => c.favourite).length;
    const groupsCount = uniqueConversations.filter(c => c.channel).length;

    const handleFilterChange = (filter) => {
        if (filter !== "all") {
            setLoader(false);
        }
        else {
            setLoader(true);
        }
        setActiveFilter(filter);
    };

    useEffect(() => {
        getSubscibedChannels();
        dispatch(fetchContacts({ selectedDomain: selectedDomain }))
    }, []);


    const getSubscibedChannels = async () => {
        try {
            const response = await UserServiceClientApi.getSubcribeChannelList();
            if (response.status === 200) {
                const list = response.data.content ?? [];
                const allImages = { ...allProfileImages };

                for (const channel of list) {
                    for (const userId of channel.participants) {
                        if (!allImages[userId]) {
                            try {
                                const img = getUserProfileImageUrlThumbnail(userId);
                                allImages[userId] = img;
                            } catch (err) {
                                console.warn("Error loading profile image for", userId, err);
                            }
                        }
                    }
                }

                dispatch(updateProfileImage(allImages));
                setSubscribedChannelsList(list);
            }
        } catch (err) {
            console.error("Error fetching subscribed channels:", err);
        }
    };

    const getGroupParticipants = async (channel) => {
        try {
            const params = {
                channelName: channel ? channel.channelName : "",
                appType,
                platform: "web",
                userDomain: selectedDomain
            }
            const response = await UserServiceClientApi.getParticipants(params);

            if (response.status === 200) {
                const participants = response.data?.content ?? []

                for (let i in participants) {
                    const profileImage = getUserProfileImageUrl(participants[i].userId)

                    if (profileImage) {
                        participants[i]["profileImage"] = profileImage
                    }
                }

                if (userData) {
                    const userDataAsParticipant = {
                        profileImage: getUserProfileImageUrl(userData.userId),
                        rankLevel1: userData?.rankLevel1 ?? "",
                        rankLevel2: userData?.rankLevel2 ?? "",
                        rankLevel3: userData?.rankLevel3 ?? "",
                        role: userData?.role ?? "",
                        userId: userData?.userId ?? "",
                        userName: userData?.userName ?? "",
                    }
                    participants.unshift(userDataAsParticipant)
                }

                dispatch(setSelectedGroupChatparticipants(participants))
            }
        } catch (err) {
            console.error("Error fetching group participanst :", err);
        }
    };

    useEffect(() => {
        if (selectedDomainDetails) {
            fetchTimeLine();
        }
    }, [selectedDomainDetails]);


    const fetchTimeLine = async () => {
        if (!isEmpty(selectedDomainDetails)) {
            try {
                await dispatch(getTimeLine(selectedDomainDetails?.userDomain));
            } catch (error) {
                console.error("Error fetching timeline:", error);
                setIsShimmerLoading(false)
            } finally {
                setIsShimmerLoading(false);
            }
        }
    };

    const handleLeaveGroup = async (userDomain, channelName) => {
        try {
            const response = await UserServiceClientApi.unsubscribeChannel(userDomain, channelName);
            dispatch(setActiveMessageChatArea(false));
            setOpenLeaveModal(false)
            getSubscibedChannels()
            fetchTimeLine()
            console.log("Successfully left the group", response);
        } catch (error) {
            console.error("Failed to leave group:", error);
        }
    };

    const handleDeleteGroup = async (channelName, userDomain) => {
        try {
            const response = await UserServiceClientApi.deleteChannel({ channelName, userDomain });
            dispatch(setActiveMessageChatArea(false));
            setOpenDeleteModal(false)
            getSubscibedChannels()
            fetchTimeLine()
            console.log("Successfully deleted the group", response);
        } catch (error) {
            console.error("Failed to deleted group:", error);
        }
    };


    const filteredConversations = Array.from(
        new Map(
            timeLine
                .filter(conv => {
                    if (activeFilter === 'groups') return conv.channel;
                    if (activeFilter === 'unread') return conv.unreadCount;
                    if (activeFilter === 'favorites') return conv.favourite;
                    return true;
                })
                .filter(conv => {
                    const name = conv?.contact?.userName || conv?.channel?.channelName || '';
                    return name.toLowerCase().includes(searchInput.toLowerCase());
                })
                .map(conv => [conv.conversationId, conv])
        ).values()
    );

    useEffect(() => {
        if (activeFilter === "all" && activeMessageChatAreaDetail) {
            setReloadChat((prev) => !prev);
            dispatch(setActiveMessageChatArea(true));
            setSelectedContact(activeMessageChatAreaDetail);
        };

        if (activeFilter !== "all") {
            dispatch(setActiveMessageChatArea(false));
        };

        if (filteredConversations.length === 0) {
            setSelectedContact(null);
            dispatch(setActiveMessageChatArea(false));
        }
    }, [searchInput, activeFilter]);

    const handleChatItemClick = async (chatItem) => {
        const contentListArray = contentList.contacts || []
        setLoader(true);
        setAvatarUrl(null);
        setOpenGroupInfo(false);
        setSelectedChatFilter(activeFilter);

        //reset script
        await fullBotScriptReset();

        // to disable chat for particular person if the user request is pending or not accepted yet.
        if (chatItem.contact && contentListArray.length > 0) {
            for (let i in contentListArray) {
                if (contentListArray[i].userId === chatItem.contact?.userId) {
                    chatItem.isRequestPendingForAccept = contentListArray[i].showAcceptIgnoreMsg
                }
            }
        };

        // Reset unread count
        const updatedTimelineList = timeLine?.map((item) => {
            if (item?.channel?.channelName && chatItem?.channel?.channelName &&
                item.channel.channelName === chatItem.channel.channelName) {
                return { ...item, unreadCount: 0 };
            }

            if (item?.contact?.userId && chatItem?.contact?.userId &&
                item.contact.userId === chatItem.contact.userId) {
                return { ...item, unreadCount: 0 };
            }

            return item;
        });

        // One-to-One Chat
        if (chatItem.contact) {
            dispatch(setSelectedGroupChat(null));
            dispatch(setSelectedOnetoOneChat(true));
            dispatch(createConversation(userData.userId, null, selectedDomain, chatItem));

            setSelectedContact(chatItem);
            dispatch(setActiveMessageChatAreaDetail(chatItem))
        }
        // Group Chat
        else if (chatItem.channel) {
            dispatch(createConversation(userData.userId, null, selectedDomain, chatItem));
            dispatch(setSelectedOnetoOneChat(false));

            const selectedChannel = subscribedChannelsList.find(
                (channel) => channel.channelName === chatItem.channel.channelName
            );

            if (!selectedChannel) {
                console.warn("Channel not found in subscribedChannelsList:", chatItem.channel.channelName);
                return;
            }
            await getGroupParticipants(selectedChannel);
            dispatch(channelAdmins(selectedChannel));
            dispatch(setSelectedGroupChat(selectedChannel));
            setSelectedContact(selectedChannel);
            dispatch(setActiveMessageChatAreaDetail(selectedChannel));
        }
        setSelectedContactDomain(chatItem?.userDomain);
        dispatch(updateTimeLine(updatedTimelineList));
        dispatch(setActiveMessageChatArea(true));
    };

const getUpdatedImg = (channelId, img) => {
    setAvatarMap(prev => ({
        ...prev,
        [channelId]: img
    }));

    setLockedMap(prev => ({
        ...prev,
        [channelId]: true   // mark it as manually updated
    }));
};


useEffect(() => {
    const loadAvatars = async () => {
        const newAvatars = {};

        const uniqueConversations = Array.from(
            new Map(
                timeLine
                    .filter((conv) => conv.contact || conv.channel)
                    .map((conv) => [conv.conversationId, conv])
            ).values()
        );

        await Promise.all(
            uniqueConversations.map(async (conv) => {
                const id = conv.conversationId;

                // 🚨 Skip manually updated avatar
                if (lockedMap[id]) return;

                const filename = conv?.contact?.userId
                    ? `${conv.contact.userId}`
                    : `${id}`;

                try {
                    const imageUrl = conv?.contact?.userId
                        ? getUserProfileImageUrlThumbnail(filename)
                        : getGroupProfileImageUrl(filename);

                    const resolvedUrl = await isValidImageUrl(imageUrl);

                    if (!resolvedUrl) {
                        const name =
                            conv?.contact?.userName ||
                            conv?.channel?.channelName ||
                            "U";

                        newAvatars[id] = getUserInitials(name);
                    } else {
                        newAvatars[id] = resolvedUrl;
                    }
                } catch (err) {
                    console.error(`Error loading avatar for ${filename}:`, err);
                }
            })
        );

        setAvatarMap(prev => ({
            ...prev,
            ...newAvatars
        }));
    };

    if (timeLine.length > 0) {
        loadAvatars();
    }
}, [timeLine, activeFilter, lockedMap]);


    return (
        <div className="bg-blue-50">
            <div className="mx-auto h-[calc(100vh-86px)] flex gap-4">
                {/* Sidebar */}
                <div className="w-[410px] bg-white border-r-gray-200 flex flex-col rounded-10 shadow-[0_5px_10px_0_rgba(37,73,242,0.15)]  p-2">
                    {/* Search */}
                    <div className="p-4">
                        <div className="flex items-center shadow-[0_5px_10px_0_rgba(37,73,242,0.15)] rounded-[10px]">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mx-2" viewBox="0 0 14 14" fill="none">
                                <path
                                    d="M6.70866 12.2498C9.76924 12.2498 12.2503 9.76875 12.2503 6.70817C12.2503 3.64759 9.76924 1.1665 6.70866 1.1665C3.64808 1.1665 1.16699 3.64759 1.16699 6.70817C1.16699 9.76875 3.64808 12.2498 6.70866 12.2498Z"
                                    stroke="#8387BD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12.8337 12.8337L11.667 11.667" stroke="#8387BD" strokeWidth="1.5"
                                    strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <input
                                type="text"
                                placeholder="Search"
                                className="w-full p-2 focus:outline-none text-size-14"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Filter Buttons */}
                    <ConnectSidebar
                        timeLine={timeLine}
                        avatarMap={avatarMap}
                        groupsCount={groupsCount}
                        unReadCount={unReadCount}
                        searchInput={searchInput}
                        activeFilter={activeFilter}
                        favouriteCount={favouriteCount}
                        selectedContact={selectedContact}
                        setSelectedContact={setSelectedContact}
                        handleFilterChange={handleFilterChange}
                        handleChatItemClick={handleChatItemClick}
                        isShimmerLoading={isShimmerLoading}
                        
                        selectedChatFilter={selectedChatFilter}
                        activeMessageChatAreaDetail={activeMessageChatAreaDetail}
                    />
                </div>
                {/* Main Chat Area */}
                <ChatScreen
                    chatLog={chatLog}
                    timeLine={timeLine}
                    getUpdatedImg={getUpdatedImg}
                    selectedContactDetails={selectedContact}
                    setSelectedContact={setSelectedContact}
                    filteredConversations={filteredConversations}
                    activeFilter={activeFilter}
                    searchInput={searchInput}
                    loader={loader}
                    setLoader={setLoader}
                    userID={userID}
                    handleLeaveGroup={handleLeaveGroup}
                    setOpenLeaveModal={setOpenLeaveModal}
                    openLeaveModal={openLeaveModal}
                    setOpenDeleteModal={setOpenDeleteModal}
                    openDeleteModal={openDeleteModal}
                    handleDeleteGroup={handleDeleteGroup}
                    setOpenGroupInfo={setOpenGroupInfo}
                    openGroupInfo={openGroupInfo}
                    setAvatarUrl={setAvatarUrl}
                    avatarUrl={avatarUrl}
                    selectedContactDomain={selectedContactDomain}
                    setReloadChat={setReloadChat}
                    reloadChat={reloadChat}
                />
            </div >
        </div >
    );
};

export default Connect;